import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-row gap-x-4 justify-between items-center my-6" }
const _hoisted_2 = { class: "mb-3 text-gray-700 font-semibold" }
const _hoisted_3 = { class: "flex flex-row gap-3" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-gray-700 font-semibold mb-2" }
const _hoisted_6 = { class: "table-fixed min-w-full w-full border-spacing-4" }
const _hoisted_7 = { class: "text text-success" }
const _hoisted_8 = { class: "columns" }
const _hoisted_9 = { class: "text-left text-gray-600 text-xs font-medium py-2 pr-2" }
const _hoisted_10 = { class: "text-left text-gray-600 text-xs font-medium p-2" }
const _hoisted_11 = { class: "text-left text-gray-600 text-xs font-medium p-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", { class: "text-left text-gray-600 text-xs font-medium py-2 pl-2" }, null, -1)
const _hoisted_13 = { class: "py-2 pr-2 w-full flex" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "mr-1 z-50 top-2 right-0 h-6 w-6 [&>svg]:stroke-current [&>svg]:h-6 [&>svg]:w-6" }
const _hoisted_16 = { class: "flex-grow flex items-center" }
const _hoisted_17 = { class: "text-gray-900 border border-gray-300 bg-white font-medium px-5 py-2.5 mr-2 rounded-lg" }
const _hoisted_18 = { class: "p-2 w-full" }
const _hoisted_19 = { class: "flex w-full" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "mr-1 z-50 top-2 right-0 h-6 w-6 [&>svg]:stroke-current [&>svg]:h-6 [&>svg]:w-6" }
const _hoisted_22 = { class: "p-2" }
const _hoisted_23 = { class: "py-2 pl-2" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "mr-1 z-50 top-0 right-0 h-6 w-6 [&>svg]:stroke-current [&>svg]:h-6 [&>svg]:w-6 hover:cursor-pointer" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "py-2 pr-2 w-full flex" }
const _hoisted_28 = { class: "z-50 mr-1 top-2 right-0 h-6 w-6 [&>svg]:stroke-current [&>svg]:h-6 [&>svg]:w-6" }
const _hoisted_29 = { class: "p-2" }
const _hoisted_30 = { class: "p-2" }
const _hoisted_31 = { class: "py-2 pl-2" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "flex items-center gap-x-3" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "flex w-full justify-center" }
const _hoisted_36 = { class: "w-full text-center" }
const _hoisted_37 = { class: "flex w-full justify-center mt-8 mb-4" }
const _hoisted_38 = {
  disabled: "",
  class: "text-gray-700 border border-gray-300 text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap disabled:opacity-50"
}
const _hoisted_39 = {
  key: 0,
  class: "flex items-center justify-center mr-2"
}
const _hoisted_40 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_41 = { class: "mt-5 text-center" }
const _hoisted_42 = { class: "text-lg font-semibold mb-1" }
const _hoisted_43 = { class: "text-center" }
const _hoisted_44 = { class: "text-sm text-gray-600 mb-8" }
const _hoisted_45 = { class: "mt-6 flex justify-around items-center flex-row" }
const _hoisted_46 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_47 = { class: "mt-5 text-center" }
const _hoisted_48 = { class: "text-lg font-semibold mb-1" }
const _hoisted_49 = { class: "text-center" }
const _hoisted_50 = { class: "text-sm text-gray-600 mb-8" }

import { ref, computed, onBeforeMount, onMounted, watchEffect } from "vue";
import { useSchoolStore } from "@/stores/schoolStore";
import { useSubjectStore } from "@/stores/subjectStore";
import { useLearnerStore } from "@/stores/learnerStore";

import {
  TrashIcon,
  XMarkIcon,
  InformationCircleIcon,
} from "@heroicons/vue/24/outline";
import { useRolloverStore } from "@/stores/rolloverStore";
import { ClassGroup } from "@/interfaces/class-group.interface";
import { Rollover } from "@/interfaces/rollover.interface";
import { unionBy } from "lodash";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import i18n from "@/plugins/i18n";

// interfaces
interface SubjectDisplay {
  id: string;
  name: string;
  show: boolean;
}

interface NewClassGroup {
  tempId: string;
  name: string;
  teacher: string;
  subject: string;
  gradeLevel: number;
  preferredLanguage: string;
}

interface NewTeacherAssignment {
  newTeacher: string;
  oldTeacher: string;
  classGroup: string;
}

interface ClassToDelete {
  teacher: string;
  classGroup: string;
  learners: number;
}

// stores

export default /*#__PURE__*/_defineComponent({
  __name: 'ClassStructureComponent',
  props: {
  gradeLevel: {
    type: Number,
    required: true,
  },
},
  emits: ['update-learner-count'],
  setup(__props, { emit }) {

const props = __props;

const schoolStore = useSchoolStore();
const subjectStore = useSubjectStore();
const learnerStore = useLearnerStore();
const rolloverStore = useRolloverStore();

// props


// refs
const subjectDisplay = ref<SubjectDisplay[]>([]);
const classesByGrade = ref<any[] | undefined>([]);
const savingLoading = ref(false);
const savingResultMessage = ref("");
const errorMessage = ref("");
const showModal = ref(false);
const newClasses = ref<NewClassGroup[]>([] as NewClassGroup[]);
const classesToDelete = ref<ClassToDelete[]>([] as ClassToDelete[]);
const newTeacherAssignments = ref<NewTeacherAssignment[]>(
  [] as NewTeacherAssignment[]
);
const showModalTwo = ref(false);

const closeModals = () => {
  showModalTwo.value = false;
};

const isClassGroupMarkedForDeletion = computed(() => (classId: string) => {
  return classesToDelete.value.some((classToDelete) => {
    return classToDelete.classGroup === classId;
  });
});

const isClassGroupMarkedForTeacherReassignment = computed(
  () => (classId: string) => {
    return newTeacherAssignments.value.some((teacherAssignment) => {
      return teacherAssignment.classGroup === classId;
    });
  }
);

const classGroupTeacherDisplayValue = computed(() => (classId: string) => {
  // If the class is marked for teacher reassignment, return the new teacher
  const teacherAssignment = newTeacherAssignments.value.some(
    (teacherAssignment) => {
      return teacherAssignment.classGroup === classId;
    }
  );

  if (teacherAssignment) {
    return newTeacherAssignments.value.find(
      (assignment) => assignment.classGroup === classId
    )?.newTeacher;
  }

  // If the class is not marked for teacher reassignment, return the current teacher
  const teacher = classesByGrade.value?.find((classGroup: ClassGroup) => {
    return classGroup._id == classId;
  })?.admins[0];

  return teacher ? teacher._id : "";
});

onBeforeMount(() => {
  const rollover = rolloverStore.rollover as Rollover;

  // set the class groups arrays
  newClasses.value = [...rollover.classGroupActions.newClasses];
  classesToDelete.value = [...rollover.classGroupActions.removedClasses];
  newTeacherAssignments.value = [
    ...rollover.classGroupActions.teachersAssignment,
  ];

  subjectDisplay.value = subjectStore.subjects.map((subject) => {
    return {
      id: subject.id,
      name: subject.name,
      show: false,
    };
  });

  classesByGrade.value = schoolStore.currentSchoolStructure?.classGroups.filter(
    (classGroup) => {
      return classGroup.gradeLevel === props.gradeLevel;
    }
  );
});

const classGroupBySubject = computed(() => (subjectId: string) => {
  return classesByGrade.value
    ?.filter((classGroup: any) => {
      return classGroup.subject == subjectId;
    })
    .map((classGroup: any) => {
      const learnersInClass = learnerStore.getSchoolLearners.filter((learner) => {
        return (
          Array.isArray(learner.classes) &&
          learner.classes.some(
            (learnerClass: any) => learnerClass.subject._id === classGroup._id
          )
        );
      }).length;

      return {
        _id: classGroup._id,
        code: classGroup.code,
        name: classGroup.name,
        learners: learnersInClass,
        school: classGroup.school,
        subject: classGroup.subject,
        gradeLevel: classGroup.gradeLevel,
        preferredLanguage: classGroup.preferredLanguage,
        assignedTeacher:
          classGroup.admins.length > 0 ? classGroup.admins[0] : null,
      };
    });
});

const schoolTeachers = computed(() => {
  const classes = schoolStore.currentSchoolStructure?.classGroups || []; // Ensure there's a fallback array
  const adminMap = new Map();

  classes.forEach((classItem) => {
    (classItem.admins || []).forEach((admin) => {
      // Ensure there's a fallback array for admins
      if (!adminMap.has(admin._id)) {
        adminMap.set(admin._id, {
          _id: admin._id,
          firstName: admin.firstName,
          lastName: admin.lastName,
        });
      }
    });
  });

  return Array.from(adminMap.values());
});

// methods
const generateUniqueUUID = () => {
  return Math.random().toString(36).substring(2) + Date.now().toString(36);
};

/**
 * Update the subjects display matrix when a subject is selected
 * @param subjectId
 */
const updateSubjects = (subjectId: string) => {
  subjectDisplay.value = subjectDisplay.value.map((subject) => {
    if (subject.id === subjectId) {
      subject.show = !subject.show;
    }
    return subject;
  });
};

// Initialize checkboxes on mount for FormKit
onMounted(() => {
  subjectDisplay.value.forEach((subject) => {
    subject.show = true; // Ensure all are checked by default
  });
});

const addNewClass = (subject: SubjectDisplay) => {
  newClasses.value.push({
    tempId: generateUniqueUUID(),
    name: "",
    teacher: "",
    subject: subject.id,
    preferredLanguage: "",
    gradeLevel: props.gradeLevel,
  });
};

const deleteNewClass = (tempId: string) => {
  newClasses.value = newClasses.value.filter((newClass) => {
    return newClass.tempId !== tempId;
  });
};

const updateTeacherAssignment = (classId: string, teacherId: string) => {
  // check if the teacher is already assigned to the class
  const teacherAlreadyAssigned = classesByGrade.value?.find(
    (classGroup: ClassGroup) => {
      return (
        classGroup._id == classId &&
        classGroup.admins.some((admin: any) => admin._id === teacherId)
      );
    }
  );

  if (teacherAlreadyAssigned) {
    // check if the teacher is in the new teacher assignments and remove them
    const teacherAssignmentIndex = newTeacherAssignments.value.findIndex(
      (assignment) => {
        return assignment.classGroup === classId;
      }
    );

    if (teacherAssignmentIndex > -1) {
      newTeacherAssignments.value.splice(teacherAssignmentIndex, 1);
    }

    return;
  }

  // check if an assignment for the class already exists and replace it
  const existingAssignment = newTeacherAssignments.value.find((assignment) => {
    return assignment.classGroup === classId;
  });

  if (existingAssignment) {
    existingAssignment.newTeacher = teacherId;
    return;
  }

  newTeacherAssignments.value.push({
    classGroup: classId,
    newTeacher: teacherId,
    // get current teacher for class
    oldTeacher:
      classesByGrade.value?.find((classGroup: ClassGroup) => {
        return classGroup._id == classId;
      })?.admins[0]?._id ?? "",
  });
};

const markExistingClassForDeletion = (
  classId: string,
  teacher: any
) => {


  // check if the class is already in the classes to delete
  const classToDeleteIndex = classesToDelete.value.findIndex(
    (classToDelete) => {
      return classToDelete.classGroup === classId;
    }
  );

  if (classToDeleteIndex > -1) {
    // classesToDelete.value.splice(classToDeleteIndex, 1);
    return;
  }

  classesToDelete.value.push({
    classGroup: classId,
    teacher: teacher ? teacher._id : null,
  });
};

const unmarkExistingClassForDeletion = (classId: string, teacher: any) => {
  classesToDelete.value = classesToDelete.value.filter((classToDelete) => {
    return classToDelete.classGroup !== classId;
  });
};

const validateNewClasses = () => {
  // Check if any class in newClasses is missing required fields
  const invalidClass = newClasses.value.some(cls => 
    cls.name.trim() === "" || 
    //cls.teacher.trim() === "" || 
    cls.preferredLanguage.trim() === ""
  );

  if (invalidClass) {
    errorMessage.value = i18n.global.t('admin_screens.grades_and_classes_screen.validation_message');
    showModal.value = true
    throw new Error("One or more classes are missing a name or preferred language.");
  }
};

const saveProgress = async () => {

  // Validate data
  validateNewClasses();

  const currentRollObject = rolloverStore.rollover as Rollover;
  console.log("Current Roll Object: ", currentRollObject);
  const { classGroupActions } = currentRollObject;

  // ******************************************************************************************************************
  // ********************************************* NEW CLASS GROUPS LOGIC *********************************************
  // ******************************************************************************************************************
  // Update or add new classes based on tempId
  classGroupActions.newClasses = newClasses.value.map((localNewClass) => {
    // Find and replace the new class in the global state
    savingLoading.value = true;
    savingResultMessage.value = "";

    const index = classGroupActions.newClasses.findIndex(
      (globalNewClass) => globalNewClass.tempId === localNewClass.tempId
    );

    if (index > -1) {
      // Update existing class if there's a change in the teacher assignment
      if (
        classGroupActions.newClasses[index].teacher !== localNewClass.teacher
      ) {

        return {
          ...classGroupActions.newClasses[index],
          teacher: localNewClass.teacher,
        };
      }
      // else return the existing class
      return classGroupActions.newClasses[index];
    } else {
      // Add new class if it doesn't exist in the global state
      return localNewClass;
    }
  });

  // Filter out new classes that no longer exist in the local state
  const updatedNewClasses = classGroupActions.newClasses.filter(
    (globalNewClass) => {
      return newClasses.value.some((localNewClass) => {
        return globalNewClass.tempId === localNewClass.tempId;
      });
    }
  );

  // Add new classes that are not in the global state
  classGroupActions.newClasses = unionBy(
    updatedNewClasses,
    newClasses.value,
    "tempId"
  );
  // ******************************************************************************************************************
  // ********************************************* NEW CLASS GROUPS LOGIC *********************************************
  // ******************************************************************************************************************

  // ******************************************************************************************************************
  // ****************************************** CLASS GROUPS TO REMOVE LOGIC ******************************************
  // ******************************************************************************************************************
  // Filter out classes to delete that no longer exist in the local state
  const updatedClassesToDelete = classGroupActions.removedClasses.filter(
    (globalClassToDelete) => {
      return classesToDelete.value.some((localClassToDelete) => {
        return globalClassToDelete.classGroup === localClassToDelete.classGroup;
      });
    }
  );

  // Add classes to delete that are not in the global state
  classGroupActions.removedClasses = unionBy(
    updatedClassesToDelete,
    classesToDelete.value,
    "classGroup"
  );

  // ******************************************************************************************************************
  // ****************************************** CLASS GROUPS TO REMOVE LOGIC ******************************************
  // ******************************************************************************************************************

  // ******************************************************************************************************************
  // ****************************************** TEACHER ASSIGNMENT LOGIC **********************************************
  // ******************************************************************************************************************
  // Filter out teacher assignments that no longer exist in the local state
  const updatedTeacherAssignments = classGroupActions.teachersAssignment.filter(
    (globalTeacherAssignment) => {
      return newTeacherAssignments.value.some((localTeacherAssignment) => {
        return (
          globalTeacherAssignment.classGroup ===
          localTeacherAssignment.classGroup
        );
      });
    }
  );

  // Add teacher assignments that are not in the global state
  classGroupActions.teachersAssignment = unionBy(
    updatedTeacherAssignments,
    newTeacherAssignments.value,
    "classGroup"
  );

  // ******************************************************************************************************************
  // ****************************************** TEACHER ASSIGNMENT LOGIC **********************************************
  // ******************************************************************************************************************

  const rolloverObjectToUpdate = rolloverStore.rollover as Rollover;
  rolloverObjectToUpdate.classGroupActions = classGroupActions;

  await rolloverStore.updateRolloverObject(rolloverObjectToUpdate);
  savingResultMessage.value = i18n.global.t(
    "rollover.review_class_structure_screen.table_content.update_success"
  );
  savingLoading.value = false;
};

// Emit function to notify the parent


// Computed property for learners in the grade
const learnersInGrade = computed(() => {
  // Filter the learners in the store by grade
  const learnersInThisGrade = learnerStore.getSchoolLearners.filter(learner => learner.grade === props.gradeLevel);

  // Get unique learner IDs (in case they belong to multiple classes)
  const uniqueLearners = new Set();
  learnersInThisGrade.forEach(learner => {
    uniqueLearners.add(learner._id); // Assuming each learner has a unique _id
  });

  return Array.from(uniqueLearners); // Convert Set back to array
});

// Emit the learner count when learnersInGrade changes
watchEffect(() => {
  const learnerCount = learnersInGrade.value.length;
  console.log(`Emitting learner count for grade ${props.gradeLevel}: ${learnerCount}`);
  emit('update-learner-count', { gradeLevel: props.gradeLevel, learnerCount });
});

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_modal = _resolveComponent("modal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.table_content.title")) + "? ", 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subjectDisplay.value, (subject) => {
            return (_openBlock(), _createBlock(_component_FormKit, {
              key: subject.id,
              type: "checkbox",
              label: subject.name,
              name: subject.name,
              modelValue: subject.show,
              "onUpdate:modelValue": ($event: any) => ((subject.show) = $event),
              onInput: ($event: any) => (updateSubjects(subject.id)),
              checked: subject.show,
              "default-checked": subject.show
            }, null, 8, ["label", "name", "modelValue", "onUpdate:modelValue", "onInput", "checked", "default-checked"]))
          }), 128))
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subjectDisplay.value, (subject) => {
        return (_openBlock(), _createElementBlock("div", {
          key: subject.id,
          class: "mb-8"
        }, [
          (subject.show)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(subject.name), 1),
                _createElementVNode("table", _hoisted_6, [
                  _createElementVNode("thead", _hoisted_7, [
                    _createElementVNode("tr", _hoisted_8, [
                      _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.table_content.grade")), 1),
                      _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.table_content.assigned_teachers")), 1),
                      _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.table_content.language")), 1),
                      _hoisted_12
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classGroupBySubject.value(
              subject.id
            ), (classGroup, classesIndex) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: classesIndex,
                        class: ""
                      }, [
                        _createElementVNode("td", _hoisted_13, [
                          (isClassGroupMarkedForDeletion.value(classGroup._id))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_15, [
                                  _createVNode(_unref(InformationCircleIcon), { class: "w-6 h-6 text-rl-base-pink-500" })
                                ])), [
                                  [
                                    _directive_tooltip,
                                    _ctx.$t('rollover.review_class_structure_screen.table_content.marked_for_deletion') + '!',
                                    "right",
                                    { tooltip: true }
                                  ]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("p", _hoisted_17, _toDisplayString(classGroup.name), 1)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            (isClassGroupMarkedForTeacherReassignment.value(classGroup._id))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                  _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_21, [
                                    _createVNode(_unref(InformationCircleIcon), { class: "w-6 h-6 text-rl-base-pink-500" })
                                  ])), [
                                    [
                                      _directive_tooltip,
                                      _ctx.$t('admin_screens.grades_and_classes_screen.new_teacher_text') + ' ' + (classGroup?.assignedTeacher.firstName || '') + ' ' + (classGroup?.assignedTeacher.lastName || ''),
                                      "right",
                                      { tooltip: true }
                                    ]
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_FormKit, {
                              type: "select",
                              name: "teacher",
                              placeholder: _ctx.$t('admin_screens.grades_and_classes_screen.select_teacher').toString(),
                              disabled: isClassGroupMarkedForDeletion.value(classGroup._id),
                              onChange: _withModifiers(($event: any) => (
                      updateTeacherAssignment(
                        classGroup._id,
                        $event.target.value
                      )
                      ), ["prevent"]),
                              value: classGroupTeacherDisplayValue.value(classGroup._id),
                              options: schoolTeachers.value.map((teacher) => {
                      return {
                        label: `${teacher.firstName} ${teacher.lastName}`,
                        value: teacher._id
                      }
                    }),
                              classes: {
                    outer: 'flex flex-grow',
                    wrapper: 'w-full',
                    input: 'w-full',
                  }
                            }, null, 8, ["placeholder", "disabled", "onChange", "value", "options"])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_22, [
                          _createVNode(_component_FormKit, {
                            type: "select",
                            name: "language",
                            value: classGroup.preferredLanguage,
                            options: [
                  { label: 'English ZA', value: 'en-ZA' },
                  { label: 'English GB', value: 'en-GB' },
                  { label: 'English AU', value: 'en-AU' },
                  { label: 'Swedish (Sweden) (sv-SE)', value: 'sv-SE' },
                  { label: 'Spanish (Peru) (es-PE)', value: 'es-PE' },
                  { label: 'Afrikaans', value: 'af-ZA' },
                ]
                          }, null, 8, ["value", "options"])
                        ]),
                        _createElementVNode("td", _hoisted_23, [
                          (isClassGroupMarkedForDeletion.value(classGroup._id))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                onClick: ($event: any) => (
                    unmarkExistingClassForDeletion(
                      classGroup._id,
                      classGroup?.assignedTeacher
                    )
                  )
                              }, [
                                _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_25, [
                                  _createVNode(_unref(XMarkIcon), { class: "w-6 h-6 text-red-400" })
                                ])), [
                                  [
                                    _directive_tooltip,
                                    _ctx.$t('rollover.review_class_structure_screen.table_content.unmark_class_tooltip'),
                                    "left",
                                    { tooltip: true }
                                  ]
                                ])
                              ], 8, _hoisted_24))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                onClick: ($event: any) => (
                  markExistingClassForDeletion(
                    classGroup._id,
                    classGroup?.assignedTeacher,
                    classGroup?.learners
                  )
                  ),
                                class: "w-10 h-10 disabled:opacity-30"
                              }, [
                                _createVNode(_unref(TrashIcon), { class: "w-6 h-6 text-red-400" })
                              ], 8, _hoisted_26))
                        ])
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newClasses.value.filter(
              (newClass) =>
                newClass.subject == subject.id &&
                newClass.gradeLevel == props.gradeLevel
            ), (newClassGroup) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: newClassGroup.tempId
                      }, [
                        _createElementVNode("td", _hoisted_27, [
                          _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_28, [
                            _createVNode(_unref(InformationCircleIcon), { class: "w-6 h-6 text-rl-base-pink-500" })
                          ])), [
                            [
                              _directive_tooltip,
                              _ctx.$t('rollover.review_class_structure_screen.table_content.new_class_added_tooltip') + '!',
                              "right",
                              { tooltip: true }
                            ]
                          ]),
                          _createVNode(_component_FormKit, {
                            type: "text",
                            name: "classCode",
                            modelValue: newClassGroup.name,
                            "onUpdate:modelValue": ($event: any) => ((newClassGroup.name) = $event),
                            placeholder: _ctx.$t('admin_screens.grades_and_classes_screen.class_name').toString(),
                            classes: {
                  outer: 'flex flex-grow',
                  wrapper: 'w-full',
                  input: 'w-full',
                }
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                        ]),
                        _createElementVNode("td", _hoisted_29, [
                          _createVNode(_component_FormKit, {
                            type: "select",
                            name: "teacher",
                            placeholder: _ctx.$t('admin_screens.grades_and_classes_screen.select_teacher').toString(),
                            modelValue: newClassGroup.teacher,
                            "onUpdate:modelValue": ($event: any) => ((newClassGroup.teacher) = $event),
                            options: schoolTeachers.value.map((teacher) => {
                    return {
                      label: `${teacher.firstName} ${teacher.lastName}`,
                      value: teacher._id
                    }
                  })
                          }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "options"])
                        ]),
                        _createElementVNode("td", _hoisted_30, [
                          _createVNode(_component_FormKit, {
                            type: "select",
                            name: "language",
                            placeholder: _ctx.$t('admin_screens.grades_and_classes_screen.language').toString(),
                            modelValue: newClassGroup.preferredLanguage,
                            "onUpdate:modelValue": ($event: any) => ((newClassGroup.preferredLanguage) = $event),
                            options: [
                    { label: 'English ZA', value: 'en-ZA' },
                    { label: 'English GB', value: 'en-GB' },
                    { label: 'English AU', value: 'en-AU' },
                    { label: 'Swedish (Sweden) (sv-SE)', value: 'sv-SE' },
                    { label: 'Spanish (Peru) (es-PE)', value: 'es-PE' },
                    { label: 'Afrikaans', value: 'af-ZA' },
                  ]
                          }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "options"])
                        ]),
                        _createElementVNode("td", _hoisted_31, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (deleteNewClass(newClassGroup.tempId)),
                            class: "w-10 h-10"
                          }, [
                            _createVNode(_unref(TrashIcon), { class: "w-6 h-6 text-red-400" })
                          ], 8, _hoisted_32)
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_33, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (addNewClass(subject)),
                          class: "text-sm bg-white border border-gray-300 rounded-lg font-semibold py-2.5 px-4 flex flex-row gap-1 mt-6"
                        }, [
                          _createVNode(_component_rl_icon, {
                            icon: 'rl-plus',
                            title: 'rl plus',
                            "aria-hidden": "true"
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.table_content.add_class")), 1)
                        ], 8, _hoisted_34)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, _toDisplayString(savingResultMessage.value), 1)
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("button", _hoisted_38, _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.table_content.cancel")), 1),
        _createElementVNode("button", {
          onClick: saveProgress,
          class: "text-white border border-blue-600 bg-blue-600 text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex flex-wrap disabled:opacity-50"
        }, [
          (savingLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' })
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(_toDisplayString(_ctx.$t("rollover.review_class_structure_screen.table_content.save")), 1)
        ])
      ]),
      _createVNode(_component_modal, {
        showCloseButton: true,
        widthClass: 'max-w-lg px-4 py-6 rounded-lg',
        open: showModalTwo.value,
        onLocalModalOpen: _cache[0] || (_cache[0] = ($event: any) => (showModalTwo.value = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              onClick: closeModals,
              class: "absolute top-4 right-4"
            }, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-large-close',
                title: 'rl large close',
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-red-fail',
                title: 'rl red fail',
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("h3", _hoisted_42, _toDisplayString(_ctx.$t("rollover.modal.review_class_structure.cant_do_header")) + ".", 1)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.$t("rollover.modal.review_class_structure.cant_do_subheader")) + ". ", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("button", {
              type: "button",
              class: "text-white border border-blue-600 bg-blue-600 text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap w-full",
              onClick: closeModals
            }, _toDisplayString(_ctx.$t("rollover.modal.review_class_structure.cant_do_btn")), 1)
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-lg px-4 py-6 rounded-lg',
      open: showModal.value,
      onLocalModalOpen: _cache[1] || (_cache[1] = ($event: any) => (showModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_rl_icon, {
              icon: 'rl-red-fail',
              title: 'rl red fail',
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("h3", _hoisted_48, _toDisplayString(_ctx.$t('bulk_learner_upload_component.invalid_data_modal.heading')), 1)
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("p", _hoisted_50, _toDisplayString(errorMessage.value), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})